export default {
    "company_header": "Company Details",
    "header_product_warning": "Signing up for the right GrabCAD product? Sign up for {0}",
    "label": {
        "first_name": "First name",
        "last_name": "Last name",
        "name": "Name",
        "company_name": "Company name",
        "university_name": "School name",
        "role": "Role",
        "company_size": "Company size",
        "phone_number": "Phone number",
        "printer": "Do you own a 3D printer?",
        "student_printer": "Does your school own a 3D printer?",
        "uses_printer_for": "What do you use your 3D printer for?",
        "shop_owner": "Are you responsible for managing your model shop?",
        "shop_users_expected": "How many people submit orders to your shop?",
        "email": "Email",
        "email_confirm": "Confirm email",
        "email_again": "Re-enter email",
        "password": "Password",
        "country": "Location",
        "state": "State/Region",
        "password_confirm": "Confirm password",
        "password_again": "Re-enter password",
        "password_hint": "Minimum 6 characters",
        "interested_in": "I'm more interested in...",
        "industry_vertical": "Industry Vertical",
        "industry_level": "Role",
        "industry_level_select": "Select Role",
        "company_size_select": "Select size",
        "business_email": "Business Email",
        "business_email_confirm": "Confirm business email",
        "industry_vertical_select": "Select Industry Vertical",
        "recaptcha": "Verify that you are not a robot"
    },
    "placeholders": {
        "name": "e.g. John Smith",
        "first": "First",
        "last": "Last",
        "email": "Enter email",
        "email_confirm": "Re-enter email",
        "password": "Enter password",
        "company_name": "Enter company name",
        "university_name": "Enter school name",
        "phone_number": "Enter phone number",
        "printer": "Select response",
        "country": "Select your country",
        "state": "Select your state or region",
        "business_email": "Enter business email",
        "business_email_confirm": "Confirm business email"
    },
    "terms": {
        "buy_now_text": "By clicking on “Next”, you confirm that you have read our",
        "workbench_text": "By clicking on “Sign up for Workbench”, you confirm that you have read our",
        "print_text": "By clicking on “Sign up“, you confirm that you have read our",
        "text": "By clicking on “Sign up for Community”, you confirm that you have read our",
        "link": "Terms of Service"
    },
	"software_terms": {
		"link": "Software Terms"
	},
    "privacy_policy": {
        "and": "and",
        "link": "Privacy Policy",
        "text": "and that you accept and agree to be bound by them."
    },
    "actions": {
        "next": "Next",
        "workbench_sign_up": "Sign up for Workbench",
        "partner_program_sign_up": "Sign up for Software Partner Program",
        "print_sign_up": "Sign up for GrabCAD Print",
        "shop_sign_up": "Sign up for GrabCAD Shop",
        "sign_up_button": "Sign up",
        "cancel": "Cancel"
    },
    "error": {
        "name_empty": "Please add your name",
        "email_taken": "This email is already registered. Please log in or choose another email.",
        "email_empty": "Please add your email",
        "email_nomatch": "Emails must match",
        "email_look": "Please enter a valid email",
        "password_nomatch": "Passwords must match",
        "password_short": "Password is too short. Should be at least 6 characters in length.",
        "password_empty": "Please enter your password",
        "recaptcha": "Click checkbox to verify you are not a robot",
        "country_blocked": "Sorry, you are not allowed to register for GrabCAD",
        "blank": "can't be blank"
    },
    "active": {
        "email": "Please enter your real e-mail, where we will send the account confirmation link."
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "No, and I don't plan to",
            "no_but_interesed": "No, but I'm interested",
            "yes_for_work": "Yes, for work",
            "yes_as_hobby": "Yes, just as a hobby",
            "yes_for_other": "Yes, for other reasons"
        },
        "student": {
            "no_dont_plan": "No, my school is not interested in 3D printing",
            "no_but_interesed": "No, but my school is currently shopping for a 3D printer",
            "yes_they_do": "Yes",
            "not_sure": "Not sure"
        }
    },
    "uses_printer_for": {
        "professional": "Professional use",
        "education": "Education/Research",
        "hobby": "Hobby",
        "dont_use": "I don't use a 3D Printer"
    },
    "level_values": {
        "administrator_principal_superintendent": "Administrator/Principal/Superintendent",
        "biomedical_engineer": "Biomedical Engineer",
        "c_level_executive": "C-level Executive",
        "clinical_preclinical": "Clinical/PreClinical",
        "dean_department_head": "Dean/Department Head",
        "dentist": "Dentist",
        "designer": "Designer",
        "educator": "Educator",
        "engineer": "Engineer",
        "equipment_manufacturer": "Equipment manufacturer",
        "lab_owner": "Lab Owner",
        "lab_technician": "Lab Technician",
        "marketing": "Marketing",
        "medical_education_and_training": "Medical Education and Training",
        "parent": "Parent",
        "practicing_physician": "Practicing Physician",
        "president_provost": "President/Provost",
        "prosthetist_orthotist": "Prosthetist/Orthotist",
        "purchasing": "Purchasing",
        "quality": "Quality",
        "rd_engineering": "R&D/Engineering",
        "sales": "Sales",
        "senior_management_administration": "Senior management/administration",
        "student": "Student",
        "training": "Training",
        "other": "Other",
        "not_employed": "Not employed"
    },
    "industry_values": {
        "aerospace": "Aerospace",
        "architecture": "Architecture",
        "arts_entertainment": "Arts and Entertainment",
        "automotive": "Automotive",
        "commercial_products": "Commercial Products",
        "consumer_electronics": "Consumer Electronics",
        "consumer_goods": "Consumer Goods",
        "dental": "Dental",
        "education": "Education",
        "engineering_consulting_service": "Engineering Consulting Service",
        "government_military": "Government/Military",
        "industrial_equipment": "Industrial Equipment",
        "jewelry": "Jewelry",
        "medical_device": "Medical Device or Equipment",
        "service_bureau": "Service Bureau",
        "toys": "Toys",
        "reseller": "Reseller",
        "other": "Other"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1,000",
        "1,000 - 2,500": "1,000 - 2,500",
        "2,500 - 5,000": "2,500 - 5,000",
        "5,000 - 10,000": "5,000 - 10,000",
        "10,000 - 15,000": "10,000 - 15,000",
        "15,000 - 20,000": "15,000 - 20,000",
        "20,000+": "20,000+",
        "not_company": "Not a company"
    },
    "yes_no_values": {
        "yes": "Yes",
        "no": "No"
    }
}
